import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrintableInvoiceCreatedByQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type PrintableInvoiceCreatedByQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null };


export const PrintableInvoiceCreatedByDocument = gql`
    query PrintableInvoiceCreatedBy($userId: String!) {
  user(_id: $userId) {
    _id
    person {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __usePrintableInvoiceCreatedByQuery__
 *
 * To run a query within a React component, call `usePrintableInvoiceCreatedByQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintableInvoiceCreatedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintableInvoiceCreatedByQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePrintableInvoiceCreatedByQuery(baseOptions: Apollo.QueryHookOptions<PrintableInvoiceCreatedByQuery, PrintableInvoiceCreatedByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintableInvoiceCreatedByQuery, PrintableInvoiceCreatedByQueryVariables>(PrintableInvoiceCreatedByDocument, options);
      }
export function usePrintableInvoiceCreatedByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintableInvoiceCreatedByQuery, PrintableInvoiceCreatedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintableInvoiceCreatedByQuery, PrintableInvoiceCreatedByQueryVariables>(PrintableInvoiceCreatedByDocument, options);
        }
export type PrintableInvoiceCreatedByQueryHookResult = ReturnType<typeof usePrintableInvoiceCreatedByQuery>;
export type PrintableInvoiceCreatedByLazyQueryHookResult = ReturnType<typeof usePrintableInvoiceCreatedByLazyQuery>;
export type PrintableInvoiceCreatedByQueryResult = Apollo.QueryResult<PrintableInvoiceCreatedByQuery, PrintableInvoiceCreatedByQueryVariables>;